(function ($) {

	/*
 *  new_map
 *
 *  This function will render a Google Map onto the selected jQuery element
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	$el (jQuery element)
 *  @return	n/a
 */

	function new_map($el) {

		//var zoom = parseInt($el.attr('data-zoom'));
		var zoom = 17;

		// var
		var $markers = $el.find('.marker');

		// vars
		var args = {
			zoom: zoom,
			zoomControlOptions: {
				position: google.maps.ControlPosition.LEFT_TOP
			},
			center: new google.maps.LatLng(0, 0),
			scaleControl: false,
			scrollwheel: false,
			navigationControl: false,
			streetViewControl: false,
			mapTypeControl: false

		};

		// Map Styles
		var mapStyles = [{
			stylers: [{ saturation: -100 }, { lightness: 20 }]
		}, {
			featureType: "poi",
			stylers: [{ visibility: "off" }]
		}];

		// create map	        	
		var map = new google.maps.Map($el[0], args);

		map.setOptions({ styles: mapStyles });

		// add a markers reference
		map.markers = [];

		// add markers
		$markers.each(function () {

			add_marker($(this), map);
		});

		// center map
		//center_map( map );
		center_map(map, zoom);
		$(window).resize(function () {
			center_map(map, zoom);
		});

		// return
		return map;
	}

	/*
 *  add_marker
 *
 *  This function will add a marker to the selected Google Map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	$marker (jQuery element)
 *  @param	map (Google Map object)
 *  @return	n/a
 */

	function add_marker($marker, map) {

		// var
		var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
		//var markerColor = $marker.attr('data-marker-color');
		var markerUrl = $marker.attr('data-marker-url');

		// create marker
		var marker = new google.maps.Marker({
			position: latlng,
			map: map,
			draggable: false,
			animation: google.maps.Animation.DROP,
			title: 'athomefactory',
			icon: new google.maps.MarkerImage(
			//'img/marker-' + markerColor + '.png',
			//'img/marker-default.png',
			markerUrl, new google.maps.Size(28, 48), new google.maps.Point(0, 0), new google.maps.Point(14, 48))
		});

		// add to array
		map.markers.push(marker);

		// if marker contains HTML, add it to an infoWindow
		if ($marker.html()) {
			// create info window
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			// show info window when marker is clicked
			google.maps.event.addListener(marker, 'click', function () {

				infowindow.open(map, marker);
			});
		}
	}

	/*
 *  center_map
 *
 *  This function will center the map, showing all markers attached to this map
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	4.3.0
 *
 *  @param	map (Google Map object)
 *  @return	n/a
 */

	function center_map(map, zoom) {

		// vars
		var bounds = new google.maps.LatLngBounds();

		// loop through all markers and create bounds
		$.each(map.markers, function (i, marker) {

			var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());

			bounds.extend(latlng);
		});

		// only 1 marker?
		if (map.markers.length == 1) {
			// set center of map
			map.setCenter(bounds.getCenter());
			map.setZoom(zoom);
		} else {
			// fit to bounds
			map.fitBounds(bounds);
		}
	}

	/*
 *  document ready
 *
 *  This function will render each map when the document is ready (page has loaded)
 *
 *  @type	function
 *  @date	8/11/2013
 *  @since	5.0.0
 *
 *  @param	n/a
 *  @return	n/a
 */
	// global var
	var map = null;

	$(document).ready(function () {

		$('.ahf-map').each(function () {

			// create map
			map = new_map($(this));

			//console.log('Map: '+$(this));
		});
	});
})(jQuery);


// WEBPACK FOOTER //
// ./js/parts/map.js